import {addOrUpdateItem, removeItem} from '../../helpers'
import * as types from '../../mutation-types'

export default {
    [types.ADD_OR_UPDATE_NOTE]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_NOTE]: (state, item) => removeItem(state, item)
}
